import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-83902bc2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 2 }
const _hoisted_2 = {
  key: 0,
  class: "label"
}
const _hoisted_3 = ["textContent"]
const _hoisted_4 = ["textContent"]

import { computed } from 'vue';

import DarkModeToggle from '@/components/btns/DarkModeToggle.vue';
import useBreakpoints from '@/composables/useBreakpoints';
import { useSidebar } from '@/composables/useSidebar';
import useWeb3 from '@/services/web3/useWeb3';

import AppNavAccountBtn from './AppNavAccountBtn.vue';
import AppNavNetworkSelect from './AppNavNetworkSelect.vue';

/**
 * COMPOSABLES
 */

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const { isMobile, isDesktop } = useBreakpoints();
const { account, connector, startConnectWithInjectedProvider } = useWeb3();
const { setSidebarOpen } = useSidebar();

/**
 * COMPUTED
 */
const hideNetworkSelect = computed(() => connector.value?.id === 'gnosis');

return (_ctx: any,_cache: any) => {
  const _component_WalletIcon = _resolveComponent("WalletIcon")!
  const _component_BalBtn = _resolveComponent("BalBtn")!
  const _component_BalIcon = _resolveComponent("BalIcon")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_unref(isMobile) ? 'actions-mobile' : 'actions-desktop')
  }, [
    (!_unref(hideNetworkSelect))
      ? (_openBlock(), _createBlock(AppNavNetworkSelect, { key: 0 }))
      : _createCommentVNode("", true),
    (_unref(account))
      ? (_openBlock(), _createBlock(AppNavAccountBtn, { key: 1 }))
      : (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_unref(isDesktop))
            ? (_openBlock(), _createElementBlock("p", _hoisted_2, "Wallet"))
            : _createCommentVNode("", true),
          _createVNode(_component_BalBtn, {
            color: "white",
            size: _unref(isMobile) ? 'md' : 'sm',
            center: false,
            onClick: _unref(startConnectWithInjectedProvider)
          }, {
            default: _withCtx(() => [
              _createVNode(_component_WalletIcon, {
                class: "mr-2",
                style: { marginLeft: '8px' }
              }),
              _createElementVNode("span", {
                class: "hidden lg:inline-block",
                textContent: _toDisplayString(_ctx.$t('connectWallet'))
              }, null, 8, _hoisted_3),
              _createElementVNode("span", {
                class: "lg:hidden",
                textContent: _toDisplayString(_ctx.$t('connect'))
              }, null, 8, _hoisted_4)
            ]),
            _: 1
          }, 8, ["size", "onClick"])
        ])),
    (_unref(isMobile))
      ? (_openBlock(), _createBlock(_component_BalBtn, {
          key: 3,
          color: "white",
          flat: "",
          circle: "",
          center: false,
          style: { marginLeft: '12px' },
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(setSidebarOpen)(true)))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_BalIcon, {
              name: "menu",
              size: "lg"
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_unref(isDesktop))
      ? (_openBlock(), _createBlock(DarkModeToggle, { key: 4 }))
      : _createCommentVNode("", true)
  ], 2))
}
}

})